import { LimitedBadges } from "../LimitedBadge";

interface ApiItem {
  id: string;
  name: string;
  publisher?: {
    username: string;
  };
  version: string;
  status: string;
  hosts: string;
  plans?: string[];
  tags?: string[];
}

interface Props {
  index: number;
  item: ApiItem;
}

const statusClass: Record<string, string> = {
  ACTIVE: "bg-blue-500",
  INACTIVE: "bg-red-500",
};

const planClass: Record<string, string> = {
  free: "bg-green-200",
  prepaid: "bg-yellow-200",
  postpaid: "bg-blue-200",
};

export function ApiTableRow({ index, item }: Props) {

  return (
    <tr className="border-b border-gray-200">
      <td className="p-3">{index}</td>
      <td className="p-3">{item.name}</td>
      <td className="p-3">{item.publisher.username}</td>
      <td className="p-3">{item.version}</td>

      <td className="p-3">
        <span
          className={`px-2.5 py-1 text-xs rounded-full text-white ${statusClass[item.status] ?? "bg-gray-400"
            }`}
        >
          {item.status}
        </span>
      </td>

      <td className="p-3">{item.hosts?.[0] ?? "-"}</td>

      <td className="p-3">
        <div className="flex gap-1.5">
          {(item.plans ?? []).map((plan) => (
            <span
              key={plan}
              className={`px-2.5 py-1 text-xs rounded-full ${planClass[plan] ?? "bg-gray-300"
                }`}
            >
              {plan}
            </span>
          ))}
        </div>
      </td>

      <td className="p-3">
        <LimitedBadges items={item.tags} />
      </td>
    </tr>
  );
}
